/**
 * @fileoverview Renders styled rows with label and value inside the styled wrapper
 */

import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { SectionLabel } from '../Section/SectionLabel'
import { SectionWrapper } from '../Section/SectionWrapper'

/**
 * Returns generated react component that contains rendered rows with label and value that were generated from props
 *
 * @param {array<Object>} props.items Array of breadcrumbs that we want to render
 *
 * @param {string || number} props.items[].label Label that will be rendered as SectionLabel
 * @param {string || number} props.items[].value Value that will be rendered under label
 *
 * @returns JSX.Element
 *
 * @example
 *  <DetailsSection
 *    items={[{ label:'Number of Missions', value: 45 }]}
 *  />
 */
const DetailsSection = ({ items }) => {
  const renderItems = items.map(({ label, value }, index) => (
    <Row
      key={`Details-row-${label}-${value}-${index}`}
      style={{ marginRight: 24 }}
    >
      <SectionLabel className="section-label">{label}</SectionLabel>
      {value}
    </Row>
  ))

  return (
    <SectionWrapper className="section-wrapper">
      <Col xs={12} style={{ display: 'flex', flexWrap: 'wrap' }}>
        {renderItems}
      </Col>
    </SectionWrapper>
  )
}

export default DetailsSection
